module.exports = __webpack_public_path__ + "static/media/LibertadMono-Black.572eab12.woff";